'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Tab = require('@material-ui/core/Tab');
var styles = require('@material-ui/core/styles');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Tab__default = /*#__PURE__*/_interopDefaultLegacy(Tab);

var ButtonTab = styles.styled(Tab__default['default'])(_ref => {
  var {
    theme
  } = _ref;
  return {
    '&:hover': {
      opacity: 1
    },
    minHeight: 'unset',
    minWidth: 96,
    [theme.breakpoints.up('md')]: {
      minWidth: 120
    },
    textTransform: 'initial'
  };
});

exports.ButtonTab = ButtonTab;
exports.default = ButtonTab;
